import { gql } from '@apollo/client';
import { USER, KUDOS } from './Types';

// Mutations

export const LOGIN_EMAIL = gql`mutation loginEmail(
  $email : String!
) {
  loginEmail (
    email: $email
  ) {
    authenticationToken
    user {
      ${USER}
    }
  }
}`;

export const GIVE_KUDOS = gql`
  mutation sendKudosMobile(
    $receivers: [String!]!,
    $level: Level!,
    $message: String!,
    $qualities: [String!],
    $publishToWall: Int,
    $badgeId: Int,
    $groupRecipients: [String!],
    $request: Int,
    $createdInApp: String!,
    $kudosAmount: Int,
    $blueKudos: Int,
    $insideKudosRecipients: [String!],
    $outsideKudosRecipients: String,
    $messageCcs: [String!],
    $attachments: [String!],
    $stickerIds: [String!]
    ) {
      sendKudosMobile(
        receivers: $receivers,
        level: $level,
        message: $message,
        qualities: $qualities,
        publishToWall: $publishToWall,
        badgeId: $badgeId,
        groupRecipients: $groupRecipients,
        request: $request,
        createdInApp: $createdInApp,
        kudosAmount: $kudosAmount,
        blueKudos: $blueKudos,
        insideKudosRecipients: $insideKudosRecipients,
        outsideKudosRecipients: $outsideKudosRecipients,
        messageCcs: $messageCcs,
        attachments: $attachments,
        stickerIds: $stickerIds
      ) {
        ${KUDOS}
      }
    }
`;
